import React, { useState } from 'react';

import { STAGE_STATUS } from '../../../../constants/cycleDetail';

import MailIcon from '../../../../design-system/Icons/MailIcon';
import ActionOption from '../../../../design-system/ActionOption/ActionOption';
import FiSquareIcon from '../../../../design-system/Icons/FiSquareIcon';
import MultiActionPopup from '../../../../design-system/MultiActionPopup/MultiActionPopup';
import CheckboxLineIcon from '../../../../design-system/Icons/CheckboxLineIcon';
import UserSharedLineIcon from '../../../../design-system/Icons/UserSharedLineIcon';

const CycleStageMultiActionPopup = ({ handleSaveChanges, onClose }) => {
    const [statusLoading, setStatusLoading] = useState(null);

    const updateStatus = async (status) => {
        setStatusLoading(status);
        await handleSaveChanges({ status });
        setStatusLoading(null);
    };

    return (
        <MultiActionPopup
            actionOptions={
                <>
                    <ActionOption
                        label="Set as Client To Do"
                        description="This will mark the stage as “Your To Do”"
                        icon={UserSharedLineIcon}
                        onClose={onClose}
                        isLoading={statusLoading === STAGE_STATUS.to_do}
                        handleAction={() => updateStatus(STAGE_STATUS.to_do)}
                    />
                    <ActionOption
                        label="Set as DiviUp To Do"
                        description="This will mark the stage as “DiviUp To Do”"
                        icon={FiSquareIcon}
                        onClose={onClose}
                        isLoading={statusLoading === STAGE_STATUS.in_progress}
                        handleAction={() => updateStatus(STAGE_STATUS.in_progress)}
                    />
                    <ActionOption
                        label="Submit for Client Review"
                        description="This will mark the stage as “Your Review”"
                        icon={MailIcon}
                        onClose={onClose}
                        isLoading={statusLoading === STAGE_STATUS.in_review}
                        handleAction={() => updateStatus(STAGE_STATUS.in_review)}
                    />
                    <ActionOption
                        label="Mark Completed"
                        description="This will mark the stage as “Completed” and start the next"
                        icon={CheckboxLineIcon}
                        onClose={onClose}
                        isLoading={statusLoading === STAGE_STATUS.success}
                        handleAction={() => updateStatus(STAGE_STATUS.success)}
                    />
                </>
            }
            onClose={onClose}
        />
    );
};
export default CycleStageMultiActionPopup;
